import { startOfMonth } from 'date-fns';
import { convertZonedDateToSystemDate, convertSystemDateToZonedDate } from './DateUtils2.js';
import { gregorianToHijri, hijriToGregorian } from './DateUtils38.js';

const getTzStartOfMonth = (tzDate, calendar = 'gregorian') => {
    const systemDate = convertZonedDateToSystemDate(tzDate);
    const hijriSystemDate = gregorianToHijri(systemDate);
    const gregorianStartOfHijriMonth = hijriToGregorian(1, hijriSystemDate.month, hijriSystemDate.year);
    const newDate = calendar === 'gregorian' ? startOfMonth(systemDate) : gregorianStartOfHijriMonth;
    return convertSystemDateToZonedDate(newDate);
};

export { getTzStartOfMonth };
